export const CrmFormTemplateId = Object.freeze({
	BookingAutoSelection: 'booking_auto_selection',
	BookingAnyResource: 'booking_any_resource',
	BookingManualSettings: 'booking_manual_settings',
});

export const CrmFormSettingsDataPropName = Object.freeze({
	autoSelection: 'autoSelection',
	default: 'default',
	isAutoSelectionOn: 'isAutoSelectionOn',
});
